import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ApplicationConfig } from 'app/global/config/application.config';

/**
 * Structural directive for showing an element based on if a feature flag is disabled.
 *
 * Usage: *featureFlagDisabled="'feature-flag-name'"
 */
@Directive({
  selector: '[featureFlagDisabled]',
})
export class FeatureFlagDisabledDirective implements OnInit {
  private disabledFlag: string = '';
  @Input() set featureFlagDisabled(val: string) {
    if (val) {
      this.disabledFlag = val;
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appConfig: ApplicationConfig,
  ) {}

  ngOnInit() {
    const isDisabled = !this.appConfig.isFeatureEnabled(this.disabledFlag);
    if (isDisabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
